module.exports = __webpack_public_path__ + "static/media/pokemon.f2ba1b46.jpg";